/**
 * Glyphs for the workspace icon keys (documentsScopes.SCOPE_ICONS, which
 * mirror the backend's list one for one). Stroke icons from the app's icon
 * set, never emoji. A key without a glyph here falls back to the folder.
 */
import {
  Archive, Book, Bookmark, Box, Briefcase, Calendar, Camera, Code, Coffee, Compass, Flag, FlaskConical,
  Folder, Globe, GraduationCap, Heart, Home, Layers, Leaf, Lightbulb, Music, PenLine, Rocket, Star,
  Target, Terminal, User, Users,
} from 'lucide-react';

export const WORKSPACE_GLYPHS = Object.freeze({
  folder: Folder,
  briefcase: Briefcase,
  home: Home,
  book: Book,
  bookmark: Bookmark,
  star: Star,
  heart: Heart,
  code: Code,
  terminal: Terminal,
  rocket: Rocket,
  flask: FlaskConical,
  globe: Globe,
  lightbulb: Lightbulb,
  layers: Layers,
  user: User,
  users: Users,
  archive: Archive,
  calendar: Calendar,
  compass: Compass,
  flag: Flag,
  pen: PenLine,
  leaf: Leaf,
  coffee: Coffee,
  music: Music,
  camera: Camera,
  graduation: GraduationCap,
  target: Target,
  box: Box,
});

export const workspaceGlyph = (key) => WORKSPACE_GLYPHS[key] || Folder;
